// extracted by mini-css-extract-plugin
module.exports = {"button":"EventRegistrationUsersPrintPage_button__FRoIf"};